module.exports = __webpack_public_path__ + "static/media/caterer-business.36ff4f50.jpg";